export const LOGIN_STATE = 'login_state'
export const USER_INFO = 'user_info'
export const LANG = 'current_lang'
